import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvService } from 'src/app/env.service';
import { ExportStatus } from 'src/app/shared/interfaces/export-status.interface';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class ExportService {
  private http = inject(HttpClient);
  private env = inject(EnvService);

  exportStatus = signal<ExportStatus | null>(null);

  private get url() {
    return this.env.apiUrl;
  }

  exportMarkdown(contentId: string, language?: string, shareToken?: string, downloadId?: string): Observable<{ zipUrl: string }> {
    return this.http.post<{ zipUrl: string }>(this.url + 'contents/export-markdown', { contentId, language, shareToken, downloadId }, httpOptions);
  }

  exportPdf(contentId: string, language?: string, shareToken?: string, downloadId?: string): Observable<{ pdfUrl: string }> {
    return this.http.post<{ pdfUrl: string }>(this.url + 'contents/export-pdf', { contentId, language, shareToken, downloadId }, httpOptions);
  }

  exportDocx(contentId: string, language?: string, shareToken?: string, downloadId?: string): Observable<{ docxUrl: string }> {
    return this.http.post<{ docxUrl: string }>(this.url + 'contents/export-docx', { contentId, language, shareToken, downloadId }, httpOptions);
  }
}
